import * as React from "react";
import { Select } from "antd";
import { ServiceContext } from "src/services/provider/Service.provider";
import { useContext, useState, useEffect } from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { IFillSelect } from 'src/services/interfaces/generic/IFillSelect';
import { ShowNotification } from '../ShowNotification/ShowNotification';
import { SelectValue } from 'antd/lib/select';
import { ISelectBankList } from 'src/services/interfaces/ISelectBankList';

interface ISelectBankProps {
  onChange: (value: SelectValue) => void;
  bankDataId?: number;
}

export const SelectBank: React.FC<ISelectBankProps & FormComponentProps> = ({ form, onChange, bankDataId }) => {
  const { bankDataService, commonDomainService } = useContext(ServiceContext);

  const [selectBankOptions, setSelectBankOptions] = useState<IFillSelect[]>([]);

  useEffect(() => {
    fetch();
  }, []);

  function fetch() {
    Promise.all([bankDataService.getByOfficer(), commonDomainService.getBankList()]).then((resp) => {
      const bankNames: ISelectBankList[] = resp[1].bank_configuration_json;

      setSelectBankOptions(
        resp[0].map((obj) => (
          {
            id: obj?.id,
            value: obj.bank + " - " + bankNames.filter(o => o.code === obj.bank)[0]?.name + " | " + obj.agency + " | " + obj.account + " - " + obj.accountDigit + " | " + obj.accountType.toString(),
            name: obj.bank + " - " + bankNames.filter(o => o.code === obj.bank)[0]?.name + " | " + obj.agency + " | " + obj.account + " - " + obj.accountDigit + " | " + obj.accountType.toString(),
            regex: null,
            pattern: null
          } as IFillSelect
        )
        )
      );
    }).catch((err) => {
      ShowNotification.Error("Erro ao carregar lista de dados bancários!", "Não foi possível carregar lista de dados bancários, entre em contato.");
    });
  }

  return (
    <>
      <PbrSelect
        name="bank-data-options"
        size="large"
        formItemProps={{ label: "Dados bancários" }}
        formWrapper={form}
        value={bankDataId}
        onChange={onChange}
        placeholder="Selecione o dado bancário"
        rules={[{ required: true, message: "Informe o dado bancário" }]}
        showSearch
      >
        {!bankDataId && <Select.Option key="" disabled value={null}>Selecione o dado bancário</Select.Option>}
        {selectBankOptions.map((obj, i) => (
          <Select.Option key={obj.id.toString()} value={obj.id}>{obj.name}</Select.Option>
        ))}
      </PbrSelect>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/SelectBank/SelectBank.tsx